export default __webpack_public_path__ + "static/media/LinkedInLogo.7fe10eff.ico";